import axios from "../axios-auth";
import orginal_axios from "axios";

export const consignmentService = {
    getConsignmentList,
    getAllConsignmentList,
    printConsignmentInvoice,
    showWindowDialog,
    printConsignmentConsignInvoice
}

function getConsignmentList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerShopName) {
        params["customerShopName"] = searchParams.customerShopName;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.marketerName) {
        params["marketerName"] = searchParams.marketerName;
    }
    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }
    return axios.get("/auth/consignments", { params });
}

function getAllConsignmentList(searchParams) {
    let params = {
        sort: "consignedDate,asc"
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.customerShopName) {
        params["customerShopName"] = searchParams.customerShopName;
    }
    if (searchParams.marketerName) {
        params["marketerName"] = searchParams.marketerName;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }
    return axios.get("/auth/consignments", { params });
}

function printConsignmentInvoice(id) {
    return orginal_axios({
        url: axios.defaults.baseURL + "/auth/print-consignment-invoice/" + id,
        method: "GET",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/pdf",
            "Content-Type": "application/json"
        }
    }).then(function (response) {
        return new Blob([response.data], { type: "application/pdf" });
    });
}

function printConsignmentConsignInvoice(id) {
    return orginal_axios({
        url: axios.defaults.baseURL + "/auth/consignment-consign-invoice/" + id,
        method: "GET",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/pdf",
            "Content-Type": "application/json"
        }
    }).then(function (response) {
        return new Blob([response.data], { type: "application/pdf" });
    });
}

function showWindowDialog(blob, fileName) {
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob);
        return;
    }

    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(blob);
    var link = document.createElement(fileName);
    link.href = data;
    link.download = fileName + ".pdf";
    window.open(link.href, fileName, "width=500,height=500");

    setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
    }, 100);
}


